<template>
  <div id="container" ref="mapRef" class="mainBox"></div>
  <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
  <div class="navBox"><Nav curNavId="1" pathUrl='gbzntjs' @circle="clickNav" /></div>
  <div class="left flexColumn">
    <div class="leftBox1 flexColumn">
      <div class="title">农作物数据</div>
      <div class="videoBox flexColumn">
        <leftBar/>

      </div>
    </div>
    <div class="leftBox2 flexColumn">
      <div class="title"> 农作物指数</div>
      <div class="xunj_box">
<!--        <leftLine/>-->
        <rightBar/>

      </div>
    </div>
    <div class="leftBox3 flexColumn">
      <div class="title">种植成本</div>
      <div class="zhong_zhi">
        <div class="cheng_ben">
          <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/jm.png">
          <span>亩均的成本（966元/亩）</span>
        </div>
        <div class="cheng_ben">
          <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/jm.png">
          <span>土地租赁成本（985元/亩）</span>
        </div>
      </div>
      <div class="leftInfo3">
        <leftPie/>


      </div>
    </div>
  </div>
  <div class="right flexColumn">
    <div class="rightBox1 flexColumn">
      <div class="title">价格趋势</div>
      <div class="rightBox1_txt">
<!--        <rightBar/>-->

        <leftLine/>



      </div>

    </div>
    <div class="rightBox2 flexColumn">
      <div class="title">农资对比</div>
      <div class="rightBox2_txt">
        <table class="table_b">
          <thead>
          <tr>
            <!-- 表头行 -->
            <th v-for="(header, index) in state.headers" :key="index">
              {{ header }}
            </th>
          </tr>
          </thead>
          <tbody>
          <!-- 表体行 -->
          <tr v-for="row in state.tableData" :key="row.id">
            <td v-for="(cell, index) in row" :key="`${row.id}-${index}`">
              {{ cell }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="jie_yue">

        <div class="jie_yue_txt" v-for="(item, index) in state.jydata" :key="index">
          {{item}}

        </div>

      </div>
    </div>
    <div class="rightBox3 flexColumn">
      <div class="title">增收数据</div>
      
      <div class="rightBox3_txt1">
        
        <div class="txt1_d1" v-for="(item, index) in state.leftData1" :key="index">
          <div class="img">
            <img :src="item.img">
          </div>
          <div class="txt1_d1_syr">
            <span>{{item.sl}}</span>
            <span>{{item.name}}</span>
          </div>
          
        </div>

      </div>
      <div class="rightBox3_txt2">
        直接受益农户年均纯收入增加850元
      </div>
      <div class="rightBox3_txt3"></div>
      <div class="rightBox3_txt1">

        <div class="txt1_d1" v-for="(item, index) in state.leftData2" :key="index">
          <div class="img">
            <img :src="item.img">
          </div>
          <div class="txt1_d1_syr">
            <span>{{item.sl}}</span>
            <span>{{item.name}}</span>
          </div>

        </div>

      </div>
      <div class="rightBox3_txt2">
        灌溉改良农户间接收益增加600元
      </div>



    </div>
  </div>
  <CircleNav :isShow="state.circleShow"  @closeCircle1="circleHiddlen"  />
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

// todo 项目使用请放开 leaflet 引入
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet/dist/leaflet.esm.js';
import Gep from "../utils/map.json";
import rightLine from "../components/xuntian/rightLine";
import leftBar from "../components/sanchanrh/leftBar";
import leftLine from "../components/sanchanrh/leftLine";
import leftPie from "../components/sanchanrh/leftPie";
import rightBar from "../components/sanchanrh/rightBar";



import Nav from "../components/nav.vue";
import CircleNav from "@/components/circleNav.vue";

// const timer = ref(null);
const router = useRouter();
const mapRef = ref(null);
const state = reactive({
  url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
  AccessToken: "",
  imgShow:false,
  circleShow:false,
  leftData1: [
    {
      name: "直接受益农户",
      sl: "8333户",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/nh.png"
     
      
    },
    {
      name: "直接受益人",
      sl: "24997人",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/nh.png"
      

    }


  ],
  leftData2: [
    {
      name: "间接灌溉受益",
      sl: "1.6万户",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/nh.png"


    },
    {
      name: "灌溉改良",
      sl: "10万亩",
      img:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/nh.png"


    }


  ],

  config3: {
    header: [
      '<span style="color:#94E894; font-size:18px;">名称</span>',
      '<span style="color:#94E894;font-size:18px;">预警时间</span>',
      '<span style="color:#94E894;font-size:18px;">报警内容</span>',

    ],
    data: [
      ["设备1","2024-03-01",  "设备异常",],
      ["设备2","2024-03-08", "设备异常", ],
      ["设备3","2024-03-15", "设备异常", ],
      ["设备4","2024-03-20", "设备异常", ],
      ["设备5","2024-03-27", "设备异常", ],
      ["设备6","2024-04-01", "设备异常", ],
      ["设备7","2024-04-07", "设备异常", ],
      ["设备8","2024-04-10", "设备异常", ],
      ["设备9","2024-03-15", "设备异常", ],
      ["设备10","2024-03-17", "设备异常",],
    ],
    headerBGC: "",
    oddRowBGC: "#102834",
    evenRowBGC: "",
    headerHeight: 40, // index: true,
    // columnWidth: [150],
    rowNum:4,
    align: ["center", "center", "center","center"], // rowNum:6
  },
  headers: ['/', '用水量', '用肥量','农药量'], // 表头数据
  tableData: [ // 表格数据
    { id: "全县小麦", 名称: '80（吨）', 数量: '60（公斤）', 数量1: '1.2（公斤）' },
    { id: "高标小麦", 名称: '60（吨）', 数量: '50（公斤）', 数量1: '0.8（公斤）' },

  ],
  jydata: ['节水25%', '节肥17%', '省药33%'],


});

const emit = defineEmits(["mapLoad"]);
const boundaryData = Gep;

const marker = ref();
const map = ref(null);
let current = ref(0);

// 地图底图
// 第一种
let mapType = ref("vec");
let mapLabelType = ref("cva");

// let mapType1 = ref(
//   L.tileLayer(
//     "https://gac-geo.googlecnapps.cn/maps/vt?lyrs=s&x={x}&y={y}&z={z}",
//     {
//       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
//     }
//   )
// );

// let mapType1 = ref(
//   L.tileLayer(
//     "http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
//     {
//       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
//     }
//   )
// );
let mapType1 = ref(
  L.tileLayer(
    "https://map1.aikenong.com.cn/maps/vt/lyrs=y&hl=zh-CN&gl=cn&scale=2&src=app&x={x}&y={y}&z={z}",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    }
  )
);
let mapLabelType1 = ref(
  L.tileLayer(
    "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&VERSION=1.0.0&REQUEST=GetTile&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
    {
      subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
    }
  )
);
// let mapLabelType1 = ref(
//   L.tileLayer(
//     "https://t{s}.tianditu.gov.cn/" +
//       "cva" +
//       "_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=" +
//       "cva" +
//       "&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=2543bd43d4f3f8b748d7ee2ecb82f74a",
//     {
//       subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
//     }
//   )
// );

const initMap = () => {
  map.value.addLayer(mapType1.value);
  map.value.addLayer(mapLabelType1.value);
  map.value.on("click", ({ latlng }) => {
    console.log("坐标：", Object.values(latlng));
  });

  return map.value;
};

const mapObj = ref();

// 在 onMounted 中初始化地图
onMounted(() => {
  // 获取视频AccessToken
  state.AccessToken = localStorage.getItem("AccessToken");
  console.log(state.AccessToken);
  const text = "为深入贯彻落实党的二十大精神，按照新形势下国家粮食安全和农业可持续发展的总体要求，深入贯彻落实“藏粮于地、藏粮于技”战略，以推进农业现代化为目标，以促进农业可持续发展为主线，加强高标准农田建设，支持生态综合治理，提高农田抗御旱涝灾害的能力，加强农业基础设施建设，改善农业生产条件，提高农业特别是粮食综合生产能力。上蔡县委、县政府根据全县经济社会发展需求和自身条件，特别是县域耕地数量、质量和农业发展现状，经过多次规划选址、研讨论证，最终选定位于县城西南部的无量寺、大路李、黄埠3个乡镇的14个行政村和1个农场、1个种子站，集中连片5万亩耕地，作为县农业现代化高标准农田示范区。其中，以吴宋湖农场周边区域1.5万亩作为核心区先行打造。";
  state.textList = chunkString(text, 44);



  map.value = L.map(mapRef.value, {
    center: [33.248258780732435, 114.18800353654662],

    // center: [114.182633, 33.240019],
    zoom: 13,
    minZoom: 3,
    maxZoom: 19,
    noWrap: true,
    // dragging: false,
    zoomControl: true,
    attributionControl: false,
  });
  mapObj.value = initMap();
  // createMarkers();
  loadBoundary();
  for (const markerDatum of markersData) {
    for (const latlng of markerDatum.locations) {
      const iconPath = require(`../assets/img/icon/${markerDatum.iconName}`);

      const marker = createAndAddMarker(latlng, {
        title: `地标`,
        icon: L.icon({
          iconUrl: iconPath,
          iconSize: [34, 48], // 图标大小
          iconAnchor: [22, 94], // 图标锚点
          popupAnchor: [-3, -76], // 弹出窗锚点
        }),
      });

      // 假设没有针对每个点定制的弹出内容，可以根据需求添加
      // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;'>${
      //   markerDatum.title ? markerDatum.title : "地标"
      // }</div>`;
      // marker.bindPopup(popupContent);
    }
  }
});
// 新增一个清除所有标记的方法
function clearMarkers() {
  // 如果map.value存在并且有layers，则遍历删除所有标记
  if (map.value && map.value.eachLayer) {
    map.value.eachLayer((layer) => {
      if (layer instanceof L.Marker) {
        map.value.removeLayer(layer);
      }
    });
  }
}
// 假设有个按钮点击事件，用buttonClick表示
function buttonClick(index) {
  // 清除所有已存在的标记
  clearMarkers();

  // 筛选出iconName为"1.png"的标记数据
  const filteredMarkers = markersData.find(
    (markerDatum) => markerDatum.iconName === index + ".png"
  );

  // 遍历筛选出来的标记数据，添加到地图上
  if (filteredMarkers) {
    for (const latlng of filteredMarkers.locations) {
      const iconPath = require(`../assets/img/icon/${filteredMarkers.iconName}`);

      const marker = createAndAddMarker(latlng, {
        title: `地标`,
        icon: L.icon({
          iconUrl: iconPath,
          iconSize: [34, 48],
          iconAnchor: [22, 94],
          popupAnchor: [-3, -76],
        }),
      });

      // 添加自定义的弹出内容
      // const popupContent = `<div style='width: 200px; height: 100px;font-size: 20px; color: aqua;border: 1px solid #19e1cb;'>${
      //   filteredMarkers.title ? filteredMarkers.title : "地标"
      // }</div>`;
      // marker.bindPopup(popupContent);
    }
  }
}

// 定义一个函数用来创建和添加Marker
function createAndAddMarker(latlng, options = {}) {
  const marker = L.marker(latlng, options);
  marker.addTo(map.value);
  return marker;
}
const markersData = [
  {
    locations: [
      [33.24496,114.19039],
      [33.243856132865304, 114.16872024536134],
      [33.23093404668792, 114.20356750488281],
    ],
    iconName: "st.png",
    // 其他相关属性...
  },

];

function createDashedPolyline(feature, style) {
  const latLngs = feature.geometry.coordinates;
  if (feature.geometry.type === "Polygon") {
    // 取外圈线作为多段线处理
    latLngs = [latLngs[0]];
  } else if (feature.geometry.type === "MultiPolygon") {
    // 处理多个多边形，这里仅取第一个外圈线
    latLngs = [latLngs[0][0]];
  }

  const options = {
    ...style,
    dashArray: [5, 5], // 虚线长度与间距
    lineCap: "round", // 线头样式，可选
    lineJoin: "round", // 线交接处样式，可选
  };

  return L.polyline(latLngs, options);
}

// 添加行政区划边界的逻辑
const loadBoundary = () => {
  L.geoJSON(boundaryData, {
    onEachFeature: function (feature, layer) {
      let style;

      switch (feature.properties.T) {
        case "未建成":
          style = {
            color: "transparent",
            fillColor: "#ECFF6D",
            fillOpacity: 0.4,
            dashArray: [5, 5],
            weight: 0,
          };
          break;
        case "其他":
          style = {
            color: "transparent",
            fillColor: "#ECFF6D",
            fillOpacity: 0.4,
            dashArray: [5, 5],
            weight: 0,
          };
          break;
        default:
          style = {
            color: "#17D3EC",
            fillColor: "#ECFF6D",
            fillOpacity: 0.4,
            dashArray: [0,0],
            weight: 1,
          };
      }

      if (
        feature.geometry.type === "Polygon" ||
        feature.geometry.type === "MultiPolygon"
      ) {
        // 设置填充样式
        layer.setStyle(style);

        // 处理每个外环线为虚线
        feature.geometry.coordinates.forEach((ring, index) => {
          if (index === 0 || feature.geometry.type === "Polygon") {
            // 对于多边形，只处理外环线
            const dashedLine = createDashedPolyline(
              { geometry: { coordinates: [ring] } },
              style
            );
            map.value.addLayer(dashedLine);
          }
        });
      } else if (
        feature.geometry.type === "LineString" ||
        feature.geometry.type === "MultiLineString"
      ) {
        const dashedLine = createDashedPolyline(feature, style);
        map.value.addLayer(dashedLine);
      }

      // 添加原始图层到地图上（用于显示填充区域）
      map.value.addLayer(layer);
    },
  }).addTo(map.value);
};

const removeMap = () => {
  if (mapObj.value) {
    mapObj.value.remove();
  }
};


// 弹出视频
function videoClick(index) {
  console.log(index);
  state.popShow = true;
  state.curVideoIndex = index;
}
// 关闭弹出
function popHiddlen() {
  state.popShow = false;
}
// 看大图
function bigImg(){
  state.imgShow=true
}
function clickImg(){
  state.imgShow=false
}
function clickNav(isShow){
  // console.log(isShow)
  state.circleShow = isShow.show
}
function circleHiddlen(data1){
  // console.log('circle')
  state.circleShow = data1.show
}

function chunkString(str, chunkSize) {
  if (str.length <= chunkSize) {
    return [str];
  }
  return [str.slice(0, chunkSize), ...chunkString(str.slice(chunkSize), chunkSize)];
}

onUnmounted(() => {
  removeMap();
});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}


.navBox{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 150px;
  background: linear-gradient( to bottom, rgba(3, 14, 25, 1) 0%,  rgba(3, 14, 25, 0.7) 60%,  rgba(3, 14, 25, 0));
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.flexColumn{
  display: flex;
  flex-direction: column;
}
.title{
  width:100%;
  height: 50px;
  font-weight: bold;
  background: url("../assets/img/huanjing/xbt.png") no-repeat left bottom;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  text-align: left;
  padding-left: 30px;
  padding-top: 15px;
}
.left,.right{
  position: fixed;
  top:100px;
  width: 468px;
  height: calc(100% - 120px);
  background: url("../assets/img/huanjing/ck.png") no-repeat;
  background-size: 100% 100%;
  z-index: 1000;

  //padding: 20px 0;
  //border: 1px solid #fff;
}

.left{
  left: 10px;
  .leftBox1{
    height: 300px;
    align-items: center;
    .videoBox{
      width: 100%;
      height: 100%;


    }
  }
  .leftBox2{
    flex: 1;
    .xunj_box{
      width: 100%;
      flex: 1;
      //padding: 20px 10px;
    }
  }
  .leftBox3{
    flex: 1;
    padding-bottom: 14px;
    .zhong_zhi{
      width: 100%;
      height: 35px;
      display: flex;
      .cheng_ben{
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
       align-items: center;
        margin-top: 10px;
        img{
          width: 35px;
          height: 35px;
        }
        span{
          display: block;
          color: #fff;
          font-size: 14px;
          line-height: 20px;
          padding-left: 8px;

        }
      }

    }
    .leftInfo3{
      width: 100%;
      flex: 1;




    }
  }
}
.right{
  right: 10px;
  .rightBox1{
    width: 100%;
    flex: 1;
    .rightBox1_txt{
      flex: 1;
      width: 100%;
      display: flex;
      flex-wrap: wrap;


    }
  }
  .rightBox2_txt{
    margin-top: 20px;
    width: 100%;
    flex: 1;

  }
  .rightBox2{
    height: 290px;
    .table_b{
      width: 92%;
      margin: 0 auto;
      height: 100%;
      color: #fff;
      font-size: 14px;
      border-collapse: collapse;
      table-layout: fixed; /* 添加这一句，使表格布局模式为固定 */
      th,
      td {
        border: 1px solid #4FF9F5;
        height: 43px;
        text-align: center;
        white-space: nowrap; /* 防止内容过长时换行，确保列宽一致 */
      }

      th {
        height: 43px;
        font-weight: bold;
        color:#28FCEF ;
      }
    }
    .jie_yue{
      width: 100%;
      height: 60px;
      //border: 1px solid #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      .jie_yue_txt{
        width: 123px;
        height: 40px;
        background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/gb.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 10px;
        color: #00E5ED;
        line-height: 40px;


      }
    }


  }
  .rightBox3{
    height: 350px;
    .rightBox3_txt1{
      width: 100%;
      height: 50px;
      display: flex;
      margin-top: 15px;
      .txt1_d1{
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .img{
        width: 46px;
        height: 45px;
        margin-left: 20px;
      }
      .txt1_d1_syr{
        height: 100%;
        flex: 1;
        span{
          display: block;
          color: #fff;
          font-size: 20px;
          text-align: left;
          text-indent: 1em;
        }
        span:first-child{
          display: block;
          color: #13D766;

        }
      }
    }
    .rightBox3_txt2{
      width: 100%;
      height: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/zj.png") no-repeat 7%;
      margin-top:25px;
      font-size: 18px;
      color: #fff;
      text-align: left;
      text-indent: 2.5em;
    }
    .rightBox3_txt3{
      width: 90%;
      margin: 8px auto ;
      height: 15px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/sanchanrh/zx.png") no-repeat ;
      background-size: 100% 100%;
    }
  }
}


</style>
